import {h, render} from 'preact';
import App from './component/App';
import ConfirmationModal from './component/ConfirmationModal';
import InfoModal from './component/InfoModal';
import $ from 'jquery';
import {Provider} from "react-redux";
import "regenerator-runtime/runtime";
import "core-js/stable";
import "./service/axiosConfig";

import store from "./store";

window.$ = $;
window.jQuery = $;
import 'jquery.qrcode';
import InUsePing from "./InUsePing";
import MainNotification from './MainNotification';

function init() {
  ConfirmationModal.init();
  InfoModal.init();

  render(
    <Provider store={ store }>
        <InUsePing/>
        <App key={'main-app'}/>
        <MainNotification />
    </Provider>, window.document.body);
}

init();
